import React, { useContext } from 'react'
import { number, string, bool } from 'prop-types'
import ReactTooltip from 'react-tooltip'

import SugarcubeContext from 'apps/SugarcubeContext'

require('./Tooltip.scss')

const EFFECT_SOLID = 'solid'
const PLACEMENT_TOP = 'top'

const Tooltip = ({ className, delayShow, effect, place, id, title, content, type, hide }) => {
    const { isKiosk } = useContext(SugarcubeContext)

    if (hide || isKiosk) {
        return null
    }
    if (type === 'major') {
        return (
            <ReactTooltip
                className={`Tooltip major ${className}`}
                delayShow={delayShow}
                delayHide={250}
                effect={effect}
                place={place}
                id={id}
            >
                <div className="tooltipContent">
                    <h5>{title}</h5>
                    <p>{content}</p>
                </div>
            </ReactTooltip>
        )
    }
    return (
        <ReactTooltip className={`Tooltip ${className}`} delayShow={delayShow} effect={effect} place={place} id={id} />
    )
}

Tooltip.defaultProps = {
    className: '',
    effect: EFFECT_SOLID,
    place: PLACEMENT_TOP,
    delayShow: 250,

    id: null,
    title: null,
    content: null,
    type: null,
    hide: false,
}

Tooltip.propTypes = {
    className: string,
    delayShow: number,
    effect: string,
    place: string,

    id: string,
    title: string,
    content: string,
    type: string,
    hide: bool,
}

export default Tooltip
